package com.xtream.ui.tv.presentation.home

import androidx.compose.animation.EnterTransition
import androidx.compose.animation.ExitTransition
import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.calculateStartPadding
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.CompositingStrategy
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import coil3.compose.ConstraintsSizeResolver
import coil3.compose.rememberAsyncImagePainter
import coil3.compose.rememberConstraintsSizeResolver
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.domain.sealed.ApiSealed
import com.xtream.composeapp.presentation.ui.ad.AdCard
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.composeapp.presentation.widget.brandLogoResource
import com.xtream.sharedResources.resources.Res
import com.xtream.composeapp.viewmodel.AdViewModel
import com.xtream.composeapp.viewmodel.DominantColorViewModel
import com.xtream.composeapp.viewmodel.HomeViewModel
import com.xtream.composeapp.viewmodel.SeriesInfoViewModel
import com.xtream.composeapp.viewmodel.VodInfoViewModel
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.dto.Ad
import com.xtream.data_kmp.dto.BaseTrending
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.TrendingMovie
import com.xtream.data_kmp.dto.TrendingTvShow
import com.xtream.data_kmp.dto.VodStream
import com.xtream.data_kmp.util.extension.addTMDBPrefixImageURL
import com.xtream.sharedResources.resources.app_logo_login_screen
import com.xtream.ui.tv.presentation.common.rememberRowFocusState
import com.xtream.ui.ui.component.extension.blendBorders
import com.xtream.ui.ui.layout.TvColumnConfig
import com.xtream.ui.ui.layout.TvColumnHeaderMode
import com.xtream.ui.ui.layout.TvContentScreen
import com.xtream.ui.ui.util.extensions.focusAlphaFade
import com.xtream.ui.ui.util.extensions.lightenColor
import com.xtream.ui.ui.widget.FocusPositioner
import com.xtream.ui.ui.widget.LazyContentRow
import com.xtream.ui.ui.widget.NetworkImageCard
import com.xtream.ui.ui.widget.Visibility
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf


data class StreamInfoState(
    val title: String? = null,
    val logoTitle: String? = null,
    val overview: String? = null,
    val rating: String? = null,
    val genre: String? = null,
    val releaseDate: String? = null,
    val duration: String? = null,
    val backdrop: String? = null,
)
@Composable
fun TvHomeScreen(
    navKey: Screen,
    modifier: Modifier = Modifier,
    contentPadding: PaddingValues = PaddingValues(vertical = 24.dp),
    rowsContentPadding: PaddingValues,
    restoreFocus: Boolean = true,
) {
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current
    val rootNavViewModel: RootNavViewModel = koinViewModel(viewModelStoreOwner = viewModelStoreOwner)
    val homeStreamsViewModel: HomeViewModel = koinViewModel()
    val adViewModel: AdViewModel = koinViewModel(key = "ad_${navKey::class.simpleName}${navKey.hashCode()}")
    val vodInfoViewModel: VodInfoViewModel = koinViewModel(parameters = { parametersOf(null) })
    val tvShowInfoViewModel: SeriesInfoViewModel = koinViewModel(parameters = { parametersOf(null) })

    val recentMap by homeStreamsViewModel.recentMap.collectAsStateWithLifecycle()
    val adState = adViewModel.bannerState

    val columnFocusRequester = remember { FocusRequester() }
    val defaultRowFocusRequester = remember { FocusRequester() }

   // var streamInfo by remember { mutableStateOf(StreamInfoState()) }
    //var pendingFocusedItem by remember { mutableStateOf<BaseStream?>(null) }
    var wasFocusedFirstTime by rememberSaveable { mutableStateOf(false) }

    val list = remember(recentMap) { recentMap?.toList() ?: emptyList() }

    val layoutDirection = LocalLayoutDirection.current
    val isRtl = layoutDirection == LayoutDirection.Rtl

    val density = LocalDensity.current
    val screenWidthDp = with(density) {
        LocalWindowInfo.current.containerSize.width.toDp()
    }


    val startPadding = rowsContentPadding.calculateStartPadding( layoutDirection)

    val parentFraction = remember(screenWidthDp) {
        startPadding.value / screenWidthDp.value
    }

    // var backdrop by remember { mutableStateOf<String?>(null) }
    // var selectedItem by remember { mutableStateOf<BaseStream?>(null) }
    // var streamInfo by remember { mutableStateOf(StreamInfoState()) }

    val colorPaletteViewModel = koinViewModel<DominantColorViewModel>(viewModelStoreOwner = viewModelStoreOwner)
    val backdropColor by colorPaletteViewModel.backdropColor
        .collectAsStateWithLifecycle()

    val defaultColor = MaterialTheme.colorScheme.background.lightenColor(-.05f)

    val animatedBgColor by animateColorAsState(
        targetValue = backdropColor ?: defaultColor,
        animationSpec = tween(800),
        label = "bgColor"
    )

    val sizeResolver: ConstraintsSizeResolver = rememberConstraintsSizeResolver()

        TvContentScreen(
            items = list,
            backgroundContent = {
             /*   BackdropImage(
                    backdrop = streamInfo.backdrop,
                    modifier = Modifier.padding(top = 20.dp)
                )*/
            },
            modifier = modifier

                .drawBehind {
                    val gradientBrush = Brush.linearGradient(
                        colors = listOf(
                            animatedBgColor,
                            animatedBgColor.copy(alpha = .5f),
                            animatedBgColor.copy(alpha = .2f),
                            Color.Transparent
                        ),
                        start = if (isRtl) {
                            Offset(0f, 0f) // Top-Left
                        } else {
                            Offset(size.width, 0f) // Top-Right
                        },
                        end = if (isRtl) {
                            Offset(size.width, size.height) // Bottom-Right
                        } else {
                            Offset(0f, size.height) // Bottom-Left
                        }
                    )

                    drawRect(brush = gradientBrush)
                }
                .graphicsLayer(compositingStrategy = CompositingStrategy.Offscreen),
            /* .graphicsLayer {
                compositingStrategy = CompositingStrategy.Offscreen
            }.drawWithContent {
                drawContent()
                drawRect(

                    brush = Brush.horizontalGradient(
                        colors = listOf(
                            Color.Black.copy(alpha = .05f),
                            Color.Black.copy(alpha = .1f),
                            Color.Black.copy(alpha = .1f),
                            Color.Black.copy(alpha = .15f),
                            Color.Black
                        ),
                        startX = 0f,
                        endX = startPadding.toPx()+15
                    ),
                    blendMode = BlendMode.DstIn // This masks the content
                )
            },*/
            columnFocusRequester = columnFocusRequester,
            defaultRowFocusRequester = defaultRowFocusRequester,
            itemKey = { index, (rowId, _) -> "$index-$rowId" }, // ✅ was bare Int
            config = TvColumnConfig(
                headerMode = TvColumnHeaderMode.AutoHide,
                backgroundAlignment = Alignment.TopEnd,
                backgroundFillFraction = 0.6f,
                backgroundHidesWithHeader = false,
                headerPadding = PaddingValues(top = 24.dp)

            ),
            // ✅ Backdrop image as background

            // ✅ Stream info panel as header
            header = {
                Row(
                    modifier= Modifier .fillMaxWidth(),
                    horizontalArrangement = Arrangement.End,
                ) {
                    Image(
                        painter = painterResource(brandLogoResource()),
                        contentDescription = stringResource(Res.string.app_logo_login_screen),

                        contentScale = ContentScale.Crop,
                        modifier = Modifier
                            .padding(horizontal = 48.dp)
                            //.padding(vertical = 24.dp, horizontal = 16.dp)
                            //.align(Alignment.TopEnd)
                            .height(30.dp)
                            .width(68.dp)   // 🔥 FIXED width + height



                    )
                }

                Spacer(modifier = Modifier.height(8.dp))
            },
            // ✅ Ad at the bottom as footer
            footer = {
                when (adState) {
                    is ApiSealed.Success<Ad> -> item {
                      //TODO  val currentLocale = LocalConfiguration.current.locales[0].language
                        val data = adState.data
                        AdCard(
                            data,
                            modifier = Modifier.onFocusChanged { focusState ->
                                /*if (focusState.isFocused) {
                                    hasInitialFocus = true
                                    pendingFocusedItem = null
                                    streamInfo = StreamInfoState(
                                        title = data.title?.localize(currentLocale),
                                        overview = data.description?.localize(currentLocale),
                                        backdrop = data.localizedImage(currentLocale),
                                    )
                                }*/
                            },
                            contentPadding = rowsContentPadding,
                            onBitmapLoaded = {palette->
                              colorPaletteViewModel.updateColorFromPalette(palette)

                            }
                        )
                    }
                    else -> {}
                }
            },
            itemRow = { _, (rowId, pair), rowFocusRequester ->
                val (aspectRatio, streams) = pair
                val focusState = rememberRowFocusState()


                if(aspectRatio == 16/9f) {
                    HomeTvCarousel(
                        items = streams,
                        modifier = Modifier
                            .padding(rowsContentPadding)
                            .padding(bottom = 24.dp),
                        color = animatedBgColor,
                        onBitmapLoaded = { url, bitmap ->
                           // colorPaletteViewModel.updateColorFromDrawable(bitmap)
                        },
                        onClick = { item ->
                            with(rootNavViewModel) {

                                when (item) {
                                    is TrendingMovie -> navigate(Screen.MovieDetail(item.streamId))
                                    is TrendingTvShow -> navigate(Screen.TvShowDetail(item.streamId))
                                }
                            }
                        }


                    )
                }
                else{
                   FocusPositioner(
                        parentFraction = parentFraction,
                        childFraction = 0f,
                    ) {
                        // var focusedIndex by remember { mutableIntStateOf(-1) }



                        LazyContentRow(
                            modifier = Modifier
                            ,
                            title = stringResource(rowId),
                            focusRequester = rowFocusRequester,
                            focusRestorer = focusState.currentRestorer,

                            contentPadding = PaddingValues( start = startPadding, end=screenWidthDp),
                        ) {

                            itemsIndexed(
                                streams,
                                key = { _, item -> "streamId_${item.streamId}" } // ✅ was bare Int
                            ) { itemIndex, stream ->


                                // 2. Determine target alpha based on focus position
                                // If an item is to the left of the focus, dim it.
                                /* val targetAlpha = if (focusedIndex != -1 && itemIndex < focusedIndex) 0.2f else 1f

                                 // 3. Animate the change
                                 val animatedAlpha by animateFloatAsState(
                                     targetValue = targetAlpha,
                                     animationSpec = tween(durationMillis = 300),
                                     label = "alphaConnector"
                                 )*/
                                NetworkImageCard(
                                    // ✅ focusState.itemModifier replaces manual rowItemFocusRequest on item 0
                                    modifier = focusState
                                        .itemModifier(itemIndex)
                                        .focusAlphaFade(
                                            itemIndex = itemIndex,
                                            lastFocusedIndex = { focusState.lastFocusedItem },
                                        )


                                    /*.graphicsLayer { alpha = animatedAlpha } // Apply the alpha
                                    .onFocusChanged { state ->
                                        if (state.isFocused) {
                                            focusedIndex = itemIndex
                                        }
                                    }*/,

                                    width = if (stream is BaseTrending) 196.dp else 124.dp,
                                    src = (stream as? BaseTrending)?.backdrop.addTMDBPrefixImageURL()
                                        ?: stream.streamIcon,
                                    title = stream.name ?: "",
                                    infoSectionVisibility = Visibility.HIDE,
                                    aspectRatio = aspectRatio,
                                    sizeResolver=sizeResolver,
                                    onBitmapLoaded =  { bitmap ->
                                        //colorPaletteViewModel.updateColorFromDrawable(bitmap)
                                    },
                                    onClick = {
                                        with(rootNavViewModel) {
                                            when (stream) {
                                                is LiveStream -> navigate(
                                                    Screen.LiveStreamPlayer(
                                                        stream.streamId,
                                                        stream.categoryId,
                                                        stream.name
                                                    )
                                                )
                                                is VodStream, is TrendingMovie -> navigate(Screen.MovieDetail(stream.streamId))
                                                is SeriesStream, is TrendingTvShow -> navigate(Screen.TvShowDetail(stream.streamId))
                                            }
                                        }
                                    }
                                )
                            }

                        }
                    }
                }

            }
        )


    LaunchedEffect(navKey) { adViewModel.loadAd(AllConst.AD_LEADERBOARD) }


    LaunchedEffect(list) {
        if(restoreFocus && !wasFocusedFirstTime)
        if(!list.isEmpty()){
           wasFocusedFirstTime= columnFocusRequester.requestFocus()

        }
    }


/*
    LaunchedEffect(selectedItem) {
        val item = selectedItem ?: return@LaunchedEffect
        delay(400)
        when (item) {
            is LiveStream -> streamInfo = StreamInfoState(title = item.name)
            is BaseTrending -> {
                streamInfo = StreamInfoState(
                    title = item.name,
                    overview = item.overview,
                    rating = item.voteAverage?.toString()?.formattedRating(),
                    releaseDate = item.releaseDate,
                    backdrop = item.backdrop.addTMDBPrefixImageURL(),
                )
                if (item is TrendingTvShow)
                    tvShowInfoViewModel.getTMDBLogo(item.id.toString(),
                        onFinished = { streamInfo = streamInfo.copy(logoTitle = it) },
                        onError = { streamInfo = streamInfo.copy(logoTitle = null) })
                else
                    vodInfoViewModel.getTMDBLogo(item.id.toString(),
                        onFinished = { streamInfo = streamInfo.copy(logoTitle = it) },
                        onError = { streamInfo = streamInfo.copy(logoTitle = null) })
            }
            is VodStream -> {
                vodInfoViewModel.loadInfo(item.streamId) { info ->
                    streamInfo = StreamInfoState(
                        title = item.name,
                        overview = info?.info?.plot,
                        rating = info?.info?.formattedRating(),
                        genre = info?.info?.genre,
                        releaseDate = info?.info?.releaseDate,
                        duration = info?.info?.duration,
                        backdrop = info?.info?.backdrop_path?.firstOrNull(),
                    )
                    vodInfoViewModel.getTMDBLogo(info?.info?.tmdb_id,
                        onFinished = { streamInfo = streamInfo.copy(logoTitle = it) },
                        onError = { streamInfo = streamInfo.copy(logoTitle = null) })
                }
            }
            is SeriesStream -> {
                tvShowInfoViewModel.loadInfo(item.streamId) { info ->
                    streamInfo = StreamInfoState(
                        title = item.name,
                        overview = info?.info?.plot,
                        rating = info?.info?.formattedRating(),
                        genre = info?.info?.genre,
                        releaseDate = info?.info?.releaseDate,
                        backdrop = info?.info?.backdrop_path?.firstOrNull(),
                    )
                }
            }
        }
    }*/

    /*LaunchedEffect(list) {
        if (!hasInitialFocus && list.isNotEmpty()) {
            list.firstOrNull()?.second?.second?.firstOrNull()?.let {
                pendingFocusedItem = it
            }
        }
    }*/
}



@Composable
fun ImmersiveList(
    streamInfo: StreamInfoState,
    containerExpandedHeight: Dp = Dp.Unspecified,
    contentPadding: PaddingValues= PaddingValues(horizontal = 48.dp),
    isExpanded: Boolean = false,
content: @Composable () -> Unit
){
    Column(

        verticalArrangement = Arrangement.Bottom

    ) {

            StreamInfoPanel(
                visible = isExpanded,
                modifier = Modifier
                    .padding(contentPadding)
                    .height(containerExpandedHeight),
                streamInfo = streamInfo
            )
        if(isExpanded)
        Spacer(Modifier.height(24.dp))

        content()
        if (containerExpandedHeight != Dp.Unspecified) {
            Spacer(Modifier.height(24.dp))
        }
    }
}

@Composable
private fun BackdropImage(
    backdrop: String?,
    modifier: Modifier = Modifier,
) {
    val painter = rememberAsyncImagePainter(backdrop)
    Image(
        painter = painter,
        contentDescription = null,
        modifier = modifier
            .fillMaxSize()
            .aspectRatio(16f / 9f)
            .graphicsLayer(compositingStrategy = CompositingStrategy.Offscreen)
            .blendBorders(),
        alignment = Alignment.Center,
        contentScale = ContentScale.Crop,
    )
}

@Composable
private fun StreamInfoPanel(
    streamInfo: StreamInfoState,
    visible: Boolean,
    modifier: Modifier = Modifier,
    enter:EnterTransition =  EnterTransition.None,
    exit: ExitTransition = ExitTransition.None
) {
    if (visible)
    CarouselDetails(
        modifier =modifier,

        title = streamInfo.title,
        description = streamInfo.overview,
        titleLogo = streamInfo.logoTitle,
        rating = streamInfo.rating,
        genre = streamInfo.genre,
        year = streamInfo.releaseDate,
        enter = enter,
        exit = exit,
       // duration = streamInfo.duration,
    )
    /*TvInfoComposeLayout(
        modifier = modifier
            .padding(rowsContentPadding)
            .padding(top = contentPadding.calculateTopPadding())
            .fillMaxWidth()
            .fillMaxHeight(.58f),
        showButtons = false,
        verticalArrangement = Arrangement.Center,
        title = streamInfo.title,
        plot = streamInfo.overview,
        logoTitle = streamInfo.logoTitle,
        rating = streamInfo.rating,
        genre = streamInfo.genre,
        releaseDate = streamInfo.releaseDate,
        duration = streamInfo.duration,
    )*/
}


